import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from "@angular/core";
import { LayoutWidget } from "../../layouts/se.layout.widget.abstract";
import { Layouts } from "../../layouts/se.layouts";
import { SeOrgSecurityStore } from "../../se.org.security.store";
import {
    EmbeddedContentMode,
    S25EmbeddedContentComponent,
} from "../../../../standalone/embedded-content/s25.embedded.content.component";

@Component({
    standalone: true,
    selector: "s25-ng-se-org-embedded-content-widget",
    imports: [S25EmbeddedContentComponent],
    template: `
        <s25-ng-embedded-content
            [source]="settingValues()['url']"
            [accessibleTitle]="settingValues()['title']"
            [mode]="mode()"
            [showConfigWarnings]="orgSecStore.canManageLayouts()"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
})
export class SeOrgEmbeddedContentWidgetComponent extends LayoutWidget<typeof SeOrgEmbeddedContentWidgetComponent> {
    static readonly META = {
        name: "Embedded Content",
        info: "Embeds content from a link or embed code. An accessible title is required.",
        settings: [
            {
                id: "url",
                label: "URL or embed code",
                info: "Paste a link or embed code. 25Live embeds, calendars, forms, videos, and social posts are supported. For long social post embed codes, paste the post's link instead.",
                type: "field" as const,
                fieldType: "textarea" as const,
            },
            { id: "title", label: "Accessible Title (required)", type: "field" as const, fieldType: "text" as const },
            {
                id: "mode",
                label: "Display Mode",
                type: "field" as const,
                fieldType: "single-select" as const,
                options: {
                    dropdownOptions: [
                        { itemId: "video", itemName: "Video (16:9 ratio)" },
                        { itemId: "panel", itemName: "Panel (fixed height)" },
                    ],
                },
            },
        ],
        defaultSettings: {
            url: "",
            title: "",
            mode: "video",
        },
    } as const satisfies Layouts.WidgetStatic;

    protected readonly orgSecStore = inject(SeOrgSecurityStore);

    protected readonly mode = computed(
        (): EmbeddedContentMode => (this.settingValues()["mode"] === "panel" ? "panel" : "video"),
    );
}
